import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "10",
      height: "14",
      x: "4",
      y: "4",
      rx: "1"
    }, null, -1),
    _createElementVNode("rect", {
      width: "10",
      height: "14",
      x: "18",
      y: "14",
      rx: "1"
    }, null, -1),
    _createElementVNode("rect", {
      width: "10",
      height: "6",
      x: "18",
      y: "4",
      rx: "1"
    }, null, -1),
    _createElementVNode("rect", {
      width: "10",
      height: "6",
      x: "4",
      y: "22",
      rx: "1"
    }, null, -1)
  ]))]))
}
export default { render: render }